import React, { useState } from 'react';
import { Modal, Form, message } from 'antd';
import AssetCategoryForm from './AssetCategoryForm';
import apiClient from '../services/api';

interface AssetCategoryModalProps {
  visible: boolean;
  onCancel: () => void;
  onSuccess: (category: any) => void;
}

const AssetCategoryModal: React.FC<AssetCategoryModalProps> = ({ visible, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleFinish = async (values: any) => {
    setLoading(true);
    try {
      const category = await apiClient.createAssetCategory(values);
      message.success('Tạo loại tài sản thành công!');
      onSuccess(category);
      form.resetFields();
    } catch (error) {
      message.error('Tạo loại tài sản thất bại!');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Tạo loại tài sản mới"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={600}
    >
      <AssetCategoryForm
        form={form}
        onFinish={handleFinish}
        loading={loading}
        submitText="Tạo mới"
      />
    </Modal>
  );
};

export default AssetCategoryModal; 